<template>
    <div id="appCapsule">
        <div class="section mt-2">
            <!-- card block -->
            <div class="card-block mb-2" v-for="card in cards" :key="card.id">
                <div class="card-main" v-if="card.status == 1">
                    <div class="balance">
                        <span class="label">Name on card</span>
                        <h1 class="title">{{ card.name }}</h1>
                    </div>
                    <div class="in">
                        <div class="card-number">
                            <span class="label">Card Number</span>
                            {{
                                card.number
                                    .replace(/[^\dA-Z]/g, "")
                                    .replace(/(.{4})/g, "$1 ")
                                    .trim()
                            }}
                        </div>
                        <div class="bottom">
                            <div class="card-expiry">
                                <span class="label">Expiry</span>
                                {{ card.expires }}
                            </div>
                            <div class="card-ccv">
                                <span class="label">CCV</span>
                                {{ card.cvv }}
                            </div>
                            <div style="margin-left: 20px;" class="card-ccv">
                                <span class="label">&nbsp;</span>
                                {{ card.card_model }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-main" v-else>
                    <div class="balance">
                        <span class="label">Generating card...</span>
                    </div>
                </div>
            </div>
            <!-- * card block -->
        </div>

        <div class="absolute-btn-container">
            <a
                href="javascript:void(0)"
                class="button"
                @click.prevent="viewCard"
            >
                <button class="x-add-acc-btn">
                    <ion-icon name="add-outline"></ion-icon>
                </button>
            </a>
            <a
                href="javascript:void(0)"
                class="button"
                id="goBackCard"
                style="display: none;"
            >
                <button class="x-add-acc-btn">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </button>
            </a>
        </div>

        <div
            style="margin-top: 70px"
            class="modal fade"
            id="modal-card"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Card Request</h5>
                        <button type="button" class="cls-mdl-btn x-closeModal">
                            <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    fill="#812655"
                                    d="M10.707 10.5l5.646-5.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.646 5.646-5.646-5.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.646 5.646-5.646 5.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l5.646-5.646 5.646 5.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-5.646-5.646z"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content">
                            <form action="" method="POST">
                                <div class="form-group">
                                    <label class="mt-form-label"
                                        >Select Account</label
                                    ><br />

                                    <select
                                        v-model="accountId"
                                        class="form-control"
                                        style="width: 100%; height: 45px;"
                                    >
                                        <option
                                            v-for="account in accounts"
                                            :key="account.id" v-if="account.isActive == 1"
                                            :value="account.id"
                                            :data-account_number="
                                                account.number
                                            "
                                            >{{ account.type }} ****
                                            {{ account.number.slice(-4) }}
                                            {{ account.currency.symbol
                                            }}{{ account.balance }}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label">Card Type</label>
                                        <div class="i-option-select">
                                            <select
                                                name="account_type"
                                                class="form-control custom-select select2-no-search"
                                                style="width: 100%; height: 50px"
                                                required
                                                v-model="card_type"
                                            >
                                                <option
                                                    value="Debit Card"
                                                    selected
                                                    >Debit Card
                                                </option>
                                                <option
                                                    value="Credit Card"
                                                    selected
                                                    >Credit Card
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label">Card Model</label>
                                        <div class="i-option-select">
                                            <select
                                                v-model="card_model"
                                                name="account_currency"
                                                class="form-control custom-select select2-no-search"
                                                style="width: 100%; height: 50px"
                                                required
                                            >
                                                <option value=""
                                                    >Select card type</option
                                                >
                                                <option value="Visa Card"
                                                    >Visa Card
                                                </option>
                                                <option value="Master Card"
                                                    >Master Card
                                                </option>
                                                <option value="American Express"
                                                    >American Express
                                                </option>
                                                <option value="Discover"
                                                    >Discover
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group basic">
                                    <button
                                        @click.prevent="requestCard"
                                        :disabled="processing"
                                        type="submit"
                                        name="add_account"
                                        class="btn btn-primary btn-block btn-lg link-loader"
                                    >
                                        {{
                                            processing
                                                ? "Processing..."
                                                : "Request Card"
                                        }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { RepositoryFactory as Repo } from "../../../repository/RepositoryFactory";
const AR = Repo.get("users");
export default {
    data() {
        return {
            investType: this.$route.params.type,
            cards: [],
            processing: false,
            currentPlan: {},
            account_type: null,
            account: null,
            card_model: "Visa Card",
            card_type: "Debit Card",
            currentCard: {},
            accounts: [],
            accountId: ''
        };
    },
    methods: {
        viewCard() {
            $("#modal-card").modal("show");
        },
        showModal() {
            $("#modal-invest").modal("show");
        },
        async requestCard() {
            this.processing = true;
            let data = {
                card_model: this.card_model,
                card_type: this.card_type,
                account: this.accountId
            };
            try {
                await AR.userCardRequest(data);
                $("#modal-card").modal("hide");
                this.processing = false;
                toast.fire({
                    type: "success",
                    title: "Card request successful"
                });
                this.loadCards();
            } catch (error) {
                this.processing = false;

                toast.fire({
                    type: "error",
                    title: error.response.data.message
                });
            }
        },
        async loadCards() {
            try {
                let res = await AR.userFetchCards();
                this.cards = res.data;
            } catch (error) {
                console.log(error);
            }
        }
    },
    created() {
        AR.loggedInUser().then(response => {
            this.user = response.data;
            this.accounts = response.data.accounts;
            this.accountId = this.accounts[0].id
        });
        this.loadCards();
    }
};
</script>
